<template>
  <div class="topbar-item">
    <div
      class="btn btn-icon w-auto d-flex align-items-center px-2"
      id="kt_quick_user_toggle"
    >
      <template v-if="!isTabletSize">
        <div class="d-flex align-items-center flex-wrap d-none d-md-flex header-user-row">
          <span
            class="font-size-base line-height-1"
            :class="[isNewLayout ? 'text-white' : 'text-dark-50']"
          >
            <span class="font-weight-bold">Hi,</span>
            <span class="font-weight-bolder ml-1">{{ employee.fullName }}</span>
          </span>
          <span
            v-if="currentCompany.name && currentCompany.name !== 'Chọn doanh nghiệp'"
            class="badge badge-pill company-badge-header ml-2"
            :style="{
              backgroundColor: getCompanyCodeColor(currentCompany.code || currentCompany.name),
              color: '#fff',
            }"
          >
            {{ currentCompany.name }}
          </span>
        </div>
      </template>
      <span class="symbol symbol-35 symbol-light-success">
        <span
          v-if="isTabletSize"
          class="w-auto px-3 symbol-label font-size-h5 font-weight-bold"
        >
          {{ employee.fullName }}
        </span>
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between pb-5"
      >
        <h3>Thông tin cá nhân</h3>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5">
            <img src="media/users/default.jpg" alt="" class="symbol-label" />
            <i class="symbol-badge bg-success"></i>
          </div>
          <div class="d-flex flex-column">
            <a
              href=""
              class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary router-link-exact-active router-link-active"
            >
              {{ employee.fullName }}
            </a>
            <div class="text-muted mt-2">
              <i class="fas fa-solid fa-hashtag"></i>
              {{ employee.id }}
            </div>
            <div class="text-muted mt-2">
              <i class="fas fa-mobile-alt" style="margin-right: 5px"></i
              >{{ employee.mobile }}
            </div>
            <div class="navi mt-2">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-text text-muted text-hover-primary">
                    <i class="fas fa-at"></i> {{ employee.email }}
                  </span></span
                ></a
              >
            </div>
            <!--begin: User Bar -->
            <button class="btn btn-light-primary btn-bold" @click="onLogout">
              Đăng xuất
            </button>
            <!--end: User Bar -->
          </div>
        </div>
        <div class="separator separator-dashed my-7"></div>
        <!--end::Header-->
        <!--begin::Company Selection-->
        <div class="navi navi-spacer-x-0 p-0">
          <div class="d-flex align-items-center p-4 bg-light-primary rounded">
            <div class="d-flex align-items-center flex-grow-1">
              <span
                v-html="tagHandler.roleIcon"
                v-b-tooltip.left
                :title="tagHandler.roleText"
                class="mr-3"
              ></span>
              <span class="font-weight-bold text-dark-75 mr-3">
                {{ tagHandler.roleTypeText }}
              </span>
              <span class="text-muted">|</span>
            </div>
            <b-dropdown
              class="dropdown-custom"
              size="sm"
              variant="primary"
              no-caret
            >
              <template #button-content>
                <span class="d-flex align-items-center">
                  <span class="font-weight-bold text-dark-75 mr-2">
                    {{ currentCompany.name }}
                  </span>
                  <i
                    class="fas fa-chevron-down text-muted"
                    style="font-size: 0.75rem"
                  ></i>
                </span>
              </template>
              <b-dropdown-group header="Chọn doanh nghiệp">
                <div v-for="(company, index) in listCompany" :key="index">
                  <b-dropdown-item-button
                    :active="currentCompany.id === company.id"
                    @click="onSelectedCompany(company)"
                    class="d-flex align-items-center"
                  >
                    <i
                      v-if="currentCompany.id === company.id"
                      class="fas fa-check text-primary mr-2"
                    ></i>
                    <span
                      :class="{
                        'font-weight-bold text-primary':
                          currentCompany.id === company.id,
                      }"
                    >
                      {{ company.name }}
                    </span>
                  </b-dropdown-item-button>
                </div>
              </b-dropdown-group>
            </b-dropdown>
          </div>
        </div>
        <!--end::Company Selection-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <!--begin::Nav-->
        <div class="navi navi-spacer-x-0 p-0">
          <router-link to="/profile/change-password" class="navi-item">
            <div class="navi-link">
              <div class="navi-text">
                <div class="font-weight-bold">Đổi mật khẩu</div>
                <div class="text-muted">Đổi mật khẩu đăng nhập</div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="navi navi-spacer-x-0 p-0">
          <router-link to="/profile/change-store" class="navi-item">
            <div class="navi-link">
              <div class="navi-text">
                <div class="font-weight-bold">Chuyển cửa hàng</div>
                <div class="text-muted">Chuyển cửa hàng của bạn</div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="separator separator-dashed my-7"></div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}

.bg-light-primary {
  background-color: #f3f6f9;
  transition: background-color 0.3s ease;
}

.bg-light-primary:hover {
  background-color: #ebedf3;
}

.dropdown-custom {
  ::v-deep .btn {
    border: none;
    background: transparent;
    padding: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    transition: all 0.3s ease;
  }

  ::v-deep .btn:hover,
  ::v-deep .btn:focus {
    background-color: rgba(0, 0, 0, 0.05);
    box-shadow: none;
  }

  ::v-deep .dropdown-menu {
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1);
    border: 1px solid #e4e6ef;
    padding: 0.5rem 0;
    margin-top: 0.5rem;
  }

  ::v-deep .dropdown-item {
    padding: 0.75rem 1.25rem;
    transition: all 0.2s ease;
  }

  ::v-deep .dropdown-item:hover {
    background-color: #f3f6f9;
  }

  ::v-deep .dropdown-item.active {
    background-color: #f3f6f9;
  }
}

.header-user-row {
  line-height: 1.2;
}

.company-badge-header {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  font-weight: 600;
  font-size: 0.7rem;
  padding: 0.25em 0.6em;
  letter-spacing: 0.02em;
}
</style>

<script>
import { LOGOUT } from '@/core/services/store/modules/auth.module';
import { RESET_MENU_WHEN_LOGOUT } from '@/core/services/store/modules/menu.module';
import KTLayoutQuickUser from '@/assets/js/layout/extended/quick-user.js';
import { getData, saveData } from '@/utils/saveDataToLocal';
import { getCompanyCodeColor } from '@/utils/common';
import KTUtil from '@/assets/js/components/util';
import { showConfirmDialog } from '@/utils/sweet-alert2';
import ApiService from '@/core/services/api.service';

export default {
  name: 'KTQuickUser',
  data() {
    return {
      employee: {},
      isTabletSize: KTUtil.isBreakpointDown('lg'),
      selectedMerchant: 1,
      storeAccessStatus: null,
      actionChangeStatus: '',
      accessInfo: {},
      isBusy: false,
      listCompany: [],
      currentCompany: {
        id: null,
        name: 'Chọn doanh nghiệp',
      },
      tagHandler: {
        roleIcon: '<i class="fas fa-building text-warning cursor-pointer"></i>',
        roleText: 'Doanh nghiệp',
        roleTypeText: 'Doanh nghiệp',
      },
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkTabletSize);
  },
  mounted() {
    KTLayoutQuickUser.init(this.$refs['kt_quick_user']);
    this.employee = this.getEmployee();
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkTabletSize);
    });
    this.fetchCompany();
  },
  methods: {
    getCompanyCodeColor,
    showConfirmDialog,
    checkTabletSize() {
      this.isTabletSize = KTUtil.isBreakpointDown('lg');
    },
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: 'login' }));
      this.$store.dispatch(RESET_MENU_WHEN_LOGOUT);
    },
    getEmployee() {
      const employeeInfo = getData('employee_info');
      if (employeeInfo) {
        const tmpInfo = JSON.parse(employeeInfo);
        return tmpInfo;
      }
      return { fullName: 'Bạn' };
    },
    fetchCompany: async function () {
      this.listCompany = [];
      await ApiService.get('v1/companies/all').then((response) => {
        this.listCompany = response.data.data;
        if (this.listCompany && this.listCompany.length > 0) {
          // Kiểm tra localStorage để khôi phục currentCompany
          const savedCompanyId = getData('currentCompanyId');
          if (savedCompanyId) {
            const savedId = parseInt(savedCompanyId);
            const foundCompany = this.listCompany.find(
              (company) => company.id === savedId,
            );
            if (foundCompany) {
              this.currentCompany = foundCompany;
              return;
            }
          }
          // Nếu không có trong localStorage hoặc không tìm thấy, chọn phần tử đầu tiên
          if (!this.currentCompany.id) {
            this.currentCompany = this.listCompany[0];
            // Lưu vào localStorage
            if (this.currentCompany.id) {
              saveData('currentCompanyId', this.currentCompany.id.toString());
            }
          }
        }
      });
    },
    onSelectedCompany(company) {
      if (company) {
        this.currentCompany = company;
        // Lưu currentCompany.id vào localStorage
        if (company.id) {
          saveData('currentCompanyId', company.id.toString());
          // Refresh lại trang web sau khi lưu
          window.location.reload();
        }
      }
    },
  },
  computed: {
    isNewLayout() {
      if (getData('config')) return true;
      return false;
    },
  },
};
</script>
